<template>
  <v-tooltip bottom color="primary" open-delay="100">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        icon
        height="38"
        width="28"
        v-on="on"
        class="ma-0 mr-2"
        @click="fullscreen()"
      >
        <v-icon color="#767676">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span style="font-size: 9px">{{ $t("Fullscreen") }}</span>
  </v-tooltip>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Fullscreen",

  computed: {
    icon() {
      return this.isFullscreen ? "fullscreen_exit" : "fullscreen";
    },

    isFullscreen() {
      return this.$store.getters.isFullscreen;
    }
  },

  methods: {
    ...mapActions(["setFullscreen"]),

    fullscreen() {
      this.setFullscreen(!this.isFullscreen);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/NavBar/Fullscreen.vue